import { useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import { useGroups } from 'commons/useGroups'

import { useSelector } from 'react-redux'
import { isEmpty } from 'ramda'
import { handleOptionsOnlyGroups } from './helpers'

export default function useGetGroups({
  selectElemText,
  selectedTags,
  generateText,
}) {
  const { formatMessage } = useIntl()
  const { fetchAllGroups } = useGroups()

  const groupList = useSelector((state) => state.groups.groupList)

  const [state, setState] = useState({
    isOpenPaper: false,
    text: selectElemText || formatMessage({ id: 'group.select.selectGroup' }),
    selectedTags: selectedTags || [],
    groups: [],
  })

  const handleGroups = useCallback(async () => {
    const groups = await handleOptionsOnlyGroups(groupList)
    setState({
      ...state,
      text: generateText(state.selectedTags, groups),
      groups: groups,
    })
  }, [groupList])

  const handlefetchAllGroups = useCallback(async () => {
    await fetchAllGroups()
  }, [fetchAllGroups])

  useEffect(() => {
    if (isEmpty(groupList)) {
      handlefetchAllGroups()
    } else handleGroups()
  }, [groupList])

  return {
    state,
    setState,
    handleGroups,
  }
}
